/* tslint:disable */
/* eslint-disable */
/**
 * ElisTech API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.0
 * Contact: info@ideatech.cz
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ApiV1SurveyExportSettingsAttachmentsAttachmentIdDelete200Response } from '../models';
// @ts-ignore
import type { ApiV1SurveyExportSettingsAttachmentsAttachmentIdGet200Response } from '../models';
// @ts-ignore
import type { ApiV1SurveyExportSettingsAttachmentsAttachmentIdPatchRequest } from '../models';
// @ts-ignore
import type { ApiV1SurveyExportSettingsGeneralGet200Response } from '../models';
// @ts-ignore
import type { ApiV1SurveyExportSettingsGeneralLangCodeGet200Response } from '../models';
// @ts-ignore
import type { ApiV1SurveyExportSettingsGeneralLangCodePatchRequest } from '../models';
// @ts-ignore
import type { ApiV1SurveyExportSettingsGeneralPatchRequest } from '../models';
// @ts-ignore
import type { ApiV1SurveyExportSettingsLogoDelete200Response } from '../models';
// @ts-ignore
import type { ApiV1SurveyExportSettingsSignatureDelete200Response } from '../models';
// @ts-ignore
import type { ApiV1SurveyExportSettingsStampDelete200Response } from '../models';
/**
 * SurveyExportSettingsApi - axios parameter creator
 */
export const SurveyExportSettingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Delete attachment from survey export settings
         * @param {string} attachmentId Attachment ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyExportSettingsAttachmentsAttachmentIdDelete: async (attachmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'attachmentId' is not null or undefined
            assertParamExists('apiV1SurveyExportSettingsAttachmentsAttachmentIdDelete', 'attachmentId', attachmentId)
            const localVarPath = `/api/v1/survey-export-settings/attachments/{attachmentId}`
                .replace('{attachmentId}', encodeURIComponent(String(attachmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete attachment from survey export settings
         * @param {string} attachmentId Attachment ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyExportSettingsAttachmentsAttachmentIdDelete_1: async (attachmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'attachmentId' is not null or undefined
            assertParamExists('apiV1SurveyExportSettingsAttachmentsAttachmentIdDelete_1', 'attachmentId', attachmentId)
            const localVarPath = `/api/v1/survey-export-settings/attachments/{attachmentId}`
                .replace('{attachmentId}', encodeURIComponent(String(attachmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get specific attachment by ID
         * @param {string} attachmentId Attachment ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyExportSettingsAttachmentsAttachmentIdGet: async (attachmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'attachmentId' is not null or undefined
            assertParamExists('apiV1SurveyExportSettingsAttachmentsAttachmentIdGet', 'attachmentId', attachmentId)
            const localVarPath = `/api/v1/survey-export-settings/attachments/{attachmentId}`
                .replace('{attachmentId}', encodeURIComponent(String(attachmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get specific attachment by ID
         * @param {string} attachmentId Attachment ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyExportSettingsAttachmentsAttachmentIdGet_2: async (attachmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'attachmentId' is not null or undefined
            assertParamExists('apiV1SurveyExportSettingsAttachmentsAttachmentIdGet_2', 'attachmentId', attachmentId)
            const localVarPath = `/api/v1/survey-export-settings/attachments/{attachmentId}`
                .replace('{attachmentId}', encodeURIComponent(String(attachmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update attachment title and active status
         * @param {string} attachmentId Attachment ID
         * @param {ApiV1SurveyExportSettingsAttachmentsAttachmentIdPatchRequest} apiV1SurveyExportSettingsAttachmentsAttachmentIdPatchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyExportSettingsAttachmentsAttachmentIdPatch: async (attachmentId: string, apiV1SurveyExportSettingsAttachmentsAttachmentIdPatchRequest: ApiV1SurveyExportSettingsAttachmentsAttachmentIdPatchRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'attachmentId' is not null or undefined
            assertParamExists('apiV1SurveyExportSettingsAttachmentsAttachmentIdPatch', 'attachmentId', attachmentId)
            // verify required parameter 'apiV1SurveyExportSettingsAttachmentsAttachmentIdPatchRequest' is not null or undefined
            assertParamExists('apiV1SurveyExportSettingsAttachmentsAttachmentIdPatch', 'apiV1SurveyExportSettingsAttachmentsAttachmentIdPatchRequest', apiV1SurveyExportSettingsAttachmentsAttachmentIdPatchRequest)
            const localVarPath = `/api/v1/survey-export-settings/attachments/{attachmentId}`
                .replace('{attachmentId}', encodeURIComponent(String(attachmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiV1SurveyExportSettingsAttachmentsAttachmentIdPatchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update attachment title and active status
         * @param {string} attachmentId Attachment ID
         * @param {ApiV1SurveyExportSettingsAttachmentsAttachmentIdPatchRequest} apiV1SurveyExportSettingsAttachmentsAttachmentIdPatchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyExportSettingsAttachmentsAttachmentIdPatch_3: async (attachmentId: string, apiV1SurveyExportSettingsAttachmentsAttachmentIdPatchRequest: ApiV1SurveyExportSettingsAttachmentsAttachmentIdPatchRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'attachmentId' is not null or undefined
            assertParamExists('apiV1SurveyExportSettingsAttachmentsAttachmentIdPatch_3', 'attachmentId', attachmentId)
            // verify required parameter 'apiV1SurveyExportSettingsAttachmentsAttachmentIdPatchRequest' is not null or undefined
            assertParamExists('apiV1SurveyExportSettingsAttachmentsAttachmentIdPatch_3', 'apiV1SurveyExportSettingsAttachmentsAttachmentIdPatchRequest', apiV1SurveyExportSettingsAttachmentsAttachmentIdPatchRequest)
            const localVarPath = `/api/v1/survey-export-settings/attachments/{attachmentId}`
                .replace('{attachmentId}', encodeURIComponent(String(attachmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiV1SurveyExportSettingsAttachmentsAttachmentIdPatchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all attachments for survey export settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyExportSettingsAttachmentsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/survey-export-settings/attachments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all attachments for survey export settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyExportSettingsAttachmentsGet_4: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/survey-export-settings/attachments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload new attachment for survey export settings
         * @param {File} attachment Attachment file
         * @param {string} [title] Optional title for the attachment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyExportSettingsAttachmentsPost: async (attachment: File, title?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'attachment' is not null or undefined
            assertParamExists('apiV1SurveyExportSettingsAttachmentsPost', 'attachment', attachment)
            const localVarPath = `/api/v1/survey-export-settings/attachments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (attachment !== undefined) { 
                localVarFormParams.append('attachment', attachment as any);
            }

            if (title !== undefined) { 
                localVarFormParams.append('title', title as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload new attachment for survey export settings
         * @param {File} attachment Attachment file
         * @param {string} [title] Optional title for the attachment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyExportSettingsAttachmentsPost_5: async (attachment: File, title?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'attachment' is not null or undefined
            assertParamExists('apiV1SurveyExportSettingsAttachmentsPost_5', 'attachment', attachment)
            const localVarPath = `/api/v1/survey-export-settings/attachments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (attachment !== undefined) { 
                localVarFormParams.append('attachment', attachment as any);
            }

            if (title !== undefined) { 
                localVarFormParams.append('title', title as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get general survey export settings version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyExportSettingsGeneralGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/survey-export-settings/general`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get general survey export settings version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyExportSettingsGeneralGet_6: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/survey-export-settings/general`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the per-language report text blocks for a report language
         * @param {string} langCode Report language code (en, de, es, sk)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyExportSettingsGeneralLangCodeGet: async (langCode: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'langCode' is not null or undefined
            assertParamExists('apiV1SurveyExportSettingsGeneralLangCodeGet', 'langCode', langCode)
            const localVarPath = `/api/v1/survey-export-settings/general/{langCode}`
                .replace('{langCode}', encodeURIComponent(String(langCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the per-language report text blocks for a report language
         * @param {string} langCode Report language code (en, de, es, sk)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyExportSettingsGeneralLangCodeGet_7: async (langCode: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'langCode' is not null or undefined
            assertParamExists('apiV1SurveyExportSettingsGeneralLangCodeGet_7', 'langCode', langCode)
            const localVarPath = `/api/v1/survey-export-settings/general/{langCode}`
                .replace('{langCode}', encodeURIComponent(String(langCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update the per-language report text blocks for a report language (creates new version)
         * @param {string} langCode Report language code (en, de, es, sk)
         * @param {ApiV1SurveyExportSettingsGeneralLangCodePatchRequest} [apiV1SurveyExportSettingsGeneralLangCodePatchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyExportSettingsGeneralLangCodePatch: async (langCode: string, apiV1SurveyExportSettingsGeneralLangCodePatchRequest?: ApiV1SurveyExportSettingsGeneralLangCodePatchRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'langCode' is not null or undefined
            assertParamExists('apiV1SurveyExportSettingsGeneralLangCodePatch', 'langCode', langCode)
            const localVarPath = `/api/v1/survey-export-settings/general/{langCode}`
                .replace('{langCode}', encodeURIComponent(String(langCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiV1SurveyExportSettingsGeneralLangCodePatchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update the per-language report text blocks for a report language (creates new version)
         * @param {string} langCode Report language code (en, de, es, sk)
         * @param {ApiV1SurveyExportSettingsGeneralLangCodePatchRequest} [apiV1SurveyExportSettingsGeneralLangCodePatchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyExportSettingsGeneralLangCodePatch_8: async (langCode: string, apiV1SurveyExportSettingsGeneralLangCodePatchRequest?: ApiV1SurveyExportSettingsGeneralLangCodePatchRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'langCode' is not null or undefined
            assertParamExists('apiV1SurveyExportSettingsGeneralLangCodePatch_8', 'langCode', langCode)
            const localVarPath = `/api/v1/survey-export-settings/general/{langCode}`
                .replace('{langCode}', encodeURIComponent(String(langCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiV1SurveyExportSettingsGeneralLangCodePatchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update general survey export settings (creates new version)
         * @param {ApiV1SurveyExportSettingsGeneralPatchRequest} [apiV1SurveyExportSettingsGeneralPatchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyExportSettingsGeneralPatch: async (apiV1SurveyExportSettingsGeneralPatchRequest?: ApiV1SurveyExportSettingsGeneralPatchRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/survey-export-settings/general`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiV1SurveyExportSettingsGeneralPatchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update general survey export settings (creates new version)
         * @param {ApiV1SurveyExportSettingsGeneralPatchRequest} [apiV1SurveyExportSettingsGeneralPatchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyExportSettingsGeneralPatch_9: async (apiV1SurveyExportSettingsGeneralPatchRequest?: ApiV1SurveyExportSettingsGeneralPatchRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/survey-export-settings/general`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiV1SurveyExportSettingsGeneralPatchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete logo from survey export settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyExportSettingsLogoDelete: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/survey-export-settings/logo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete logo from survey export settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyExportSettingsLogoDelete_10: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/survey-export-settings/logo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get survey export settings for user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyExportSettingsLogoGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/survey-export-settings/logo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get survey export settings for user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyExportSettingsLogoGet_11: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/survey-export-settings/logo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload logo for survey export settings
         * @param {File} logo Logo file (JPEG, PNG, GIF, WebP)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyExportSettingsLogoPost: async (logo: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'logo' is not null or undefined
            assertParamExists('apiV1SurveyExportSettingsLogoPost', 'logo', logo)
            const localVarPath = `/api/v1/survey-export-settings/logo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (logo !== undefined) { 
                localVarFormParams.append('logo', logo as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload logo for survey export settings
         * @param {File} logo Logo file (JPEG, PNG, GIF, WebP)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyExportSettingsLogoPost_12: async (logo: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'logo' is not null or undefined
            assertParamExists('apiV1SurveyExportSettingsLogoPost_12', 'logo', logo)
            const localVarPath = `/api/v1/survey-export-settings/logo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (logo !== undefined) { 
                localVarFormParams.append('logo', logo as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete signature from survey export settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyExportSettingsSignatureDelete: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/survey-export-settings/signature`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete signature from survey export settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyExportSettingsSignatureDelete_13: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/survey-export-settings/signature`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get signature for survey export settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyExportSettingsSignatureGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/survey-export-settings/signature`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get signature for survey export settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyExportSettingsSignatureGet_14: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/survey-export-settings/signature`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload new signature for survey export settings
         * @param {File} signature Signature file (JPEG, PNG, GIF, WebP)
         * @param {string} title Title for the signature
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyExportSettingsSignaturePost: async (signature: File, title: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'signature' is not null or undefined
            assertParamExists('apiV1SurveyExportSettingsSignaturePost', 'signature', signature)
            // verify required parameter 'title' is not null or undefined
            assertParamExists('apiV1SurveyExportSettingsSignaturePost', 'title', title)
            const localVarPath = `/api/v1/survey-export-settings/signature`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (signature !== undefined) { 
                localVarFormParams.append('signature', signature as any);
            }

            if (title !== undefined) { 
                localVarFormParams.append('title', title as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload new signature for survey export settings
         * @param {File} signature Signature file (JPEG, PNG, GIF, WebP)
         * @param {string} title Title for the signature
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyExportSettingsSignaturePost_15: async (signature: File, title: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'signature' is not null or undefined
            assertParamExists('apiV1SurveyExportSettingsSignaturePost_15', 'signature', signature)
            // verify required parameter 'title' is not null or undefined
            assertParamExists('apiV1SurveyExportSettingsSignaturePost_15', 'title', title)
            const localVarPath = `/api/v1/survey-export-settings/signature`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (signature !== undefined) { 
                localVarFormParams.append('signature', signature as any);
            }

            if (title !== undefined) { 
                localVarFormParams.append('title', title as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete stamp from survey export settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyExportSettingsStampDelete: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/survey-export-settings/stamp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete stamp from survey export settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyExportSettingsStampDelete_16: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/survey-export-settings/stamp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get stamp for survey export settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyExportSettingsStampGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/survey-export-settings/stamp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get stamp for survey export settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyExportSettingsStampGet_17: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/survey-export-settings/stamp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload new stamp for survey export settings
         * @param {File} stamp Stamp file (JPEG, PNG, GIF, WebP)
         * @param {string} title Title for the stamp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyExportSettingsStampPost: async (stamp: File, title: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stamp' is not null or undefined
            assertParamExists('apiV1SurveyExportSettingsStampPost', 'stamp', stamp)
            // verify required parameter 'title' is not null or undefined
            assertParamExists('apiV1SurveyExportSettingsStampPost', 'title', title)
            const localVarPath = `/api/v1/survey-export-settings/stamp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (stamp !== undefined) { 
                localVarFormParams.append('stamp', stamp as any);
            }

            if (title !== undefined) { 
                localVarFormParams.append('title', title as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload new stamp for survey export settings
         * @param {File} stamp Stamp file (JPEG, PNG, GIF, WebP)
         * @param {string} title Title for the stamp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyExportSettingsStampPost_18: async (stamp: File, title: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stamp' is not null or undefined
            assertParamExists('apiV1SurveyExportSettingsStampPost_18', 'stamp', stamp)
            // verify required parameter 'title' is not null or undefined
            assertParamExists('apiV1SurveyExportSettingsStampPost_18', 'title', title)
            const localVarPath = `/api/v1/survey-export-settings/stamp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (stamp !== undefined) { 
                localVarFormParams.append('stamp', stamp as any);
            }

            if (title !== undefined) { 
                localVarFormParams.append('title', title as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SurveyExportSettingsApi - functional programming interface
 */
export const SurveyExportSettingsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SurveyExportSettingsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Delete attachment from survey export settings
         * @param {string} attachmentId Attachment ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SurveyExportSettingsAttachmentsAttachmentIdDelete(attachmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1SurveyExportSettingsAttachmentsAttachmentIdDelete200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SurveyExportSettingsAttachmentsAttachmentIdDelete(attachmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyExportSettingsApi.apiV1SurveyExportSettingsAttachmentsAttachmentIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete attachment from survey export settings
         * @param {string} attachmentId Attachment ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SurveyExportSettingsAttachmentsAttachmentIdDelete_1(attachmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1SurveyExportSettingsAttachmentsAttachmentIdDelete200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SurveyExportSettingsAttachmentsAttachmentIdDelete_1(attachmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyExportSettingsApi.apiV1SurveyExportSettingsAttachmentsAttachmentIdDelete_1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get specific attachment by ID
         * @param {string} attachmentId Attachment ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SurveyExportSettingsAttachmentsAttachmentIdGet(attachmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1SurveyExportSettingsAttachmentsAttachmentIdGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SurveyExportSettingsAttachmentsAttachmentIdGet(attachmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyExportSettingsApi.apiV1SurveyExportSettingsAttachmentsAttachmentIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get specific attachment by ID
         * @param {string} attachmentId Attachment ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SurveyExportSettingsAttachmentsAttachmentIdGet_2(attachmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1SurveyExportSettingsAttachmentsAttachmentIdGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SurveyExportSettingsAttachmentsAttachmentIdGet_2(attachmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyExportSettingsApi.apiV1SurveyExportSettingsAttachmentsAttachmentIdGet_2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update attachment title and active status
         * @param {string} attachmentId Attachment ID
         * @param {ApiV1SurveyExportSettingsAttachmentsAttachmentIdPatchRequest} apiV1SurveyExportSettingsAttachmentsAttachmentIdPatchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SurveyExportSettingsAttachmentsAttachmentIdPatch(attachmentId: string, apiV1SurveyExportSettingsAttachmentsAttachmentIdPatchRequest: ApiV1SurveyExportSettingsAttachmentsAttachmentIdPatchRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1SurveyExportSettingsAttachmentsAttachmentIdGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SurveyExportSettingsAttachmentsAttachmentIdPatch(attachmentId, apiV1SurveyExportSettingsAttachmentsAttachmentIdPatchRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyExportSettingsApi.apiV1SurveyExportSettingsAttachmentsAttachmentIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update attachment title and active status
         * @param {string} attachmentId Attachment ID
         * @param {ApiV1SurveyExportSettingsAttachmentsAttachmentIdPatchRequest} apiV1SurveyExportSettingsAttachmentsAttachmentIdPatchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SurveyExportSettingsAttachmentsAttachmentIdPatch_3(attachmentId: string, apiV1SurveyExportSettingsAttachmentsAttachmentIdPatchRequest: ApiV1SurveyExportSettingsAttachmentsAttachmentIdPatchRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1SurveyExportSettingsAttachmentsAttachmentIdGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SurveyExportSettingsAttachmentsAttachmentIdPatch_3(attachmentId, apiV1SurveyExportSettingsAttachmentsAttachmentIdPatchRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyExportSettingsApi.apiV1SurveyExportSettingsAttachmentsAttachmentIdPatch_3']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all attachments for survey export settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SurveyExportSettingsAttachmentsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1SurveyExportSettingsAttachmentsAttachmentIdGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SurveyExportSettingsAttachmentsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyExportSettingsApi.apiV1SurveyExportSettingsAttachmentsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all attachments for survey export settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SurveyExportSettingsAttachmentsGet_4(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1SurveyExportSettingsAttachmentsAttachmentIdGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SurveyExportSettingsAttachmentsGet_4(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyExportSettingsApi.apiV1SurveyExportSettingsAttachmentsGet_4']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Upload new attachment for survey export settings
         * @param {File} attachment Attachment file
         * @param {string} [title] Optional title for the attachment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SurveyExportSettingsAttachmentsPost(attachment: File, title?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1SurveyExportSettingsAttachmentsAttachmentIdGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SurveyExportSettingsAttachmentsPost(attachment, title, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyExportSettingsApi.apiV1SurveyExportSettingsAttachmentsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Upload new attachment for survey export settings
         * @param {File} attachment Attachment file
         * @param {string} [title] Optional title for the attachment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SurveyExportSettingsAttachmentsPost_5(attachment: File, title?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1SurveyExportSettingsAttachmentsAttachmentIdGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SurveyExportSettingsAttachmentsPost_5(attachment, title, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyExportSettingsApi.apiV1SurveyExportSettingsAttachmentsPost_5']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get general survey export settings version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SurveyExportSettingsGeneralGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1SurveyExportSettingsGeneralGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SurveyExportSettingsGeneralGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyExportSettingsApi.apiV1SurveyExportSettingsGeneralGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get general survey export settings version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SurveyExportSettingsGeneralGet_6(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1SurveyExportSettingsGeneralGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SurveyExportSettingsGeneralGet_6(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyExportSettingsApi.apiV1SurveyExportSettingsGeneralGet_6']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get the per-language report text blocks for a report language
         * @param {string} langCode Report language code (en, de, es, sk)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SurveyExportSettingsGeneralLangCodeGet(langCode: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1SurveyExportSettingsGeneralLangCodeGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SurveyExportSettingsGeneralLangCodeGet(langCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyExportSettingsApi.apiV1SurveyExportSettingsGeneralLangCodeGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get the per-language report text blocks for a report language
         * @param {string} langCode Report language code (en, de, es, sk)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SurveyExportSettingsGeneralLangCodeGet_7(langCode: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1SurveyExportSettingsGeneralLangCodeGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SurveyExportSettingsGeneralLangCodeGet_7(langCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyExportSettingsApi.apiV1SurveyExportSettingsGeneralLangCodeGet_7']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update the per-language report text blocks for a report language (creates new version)
         * @param {string} langCode Report language code (en, de, es, sk)
         * @param {ApiV1SurveyExportSettingsGeneralLangCodePatchRequest} [apiV1SurveyExportSettingsGeneralLangCodePatchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SurveyExportSettingsGeneralLangCodePatch(langCode: string, apiV1SurveyExportSettingsGeneralLangCodePatchRequest?: ApiV1SurveyExportSettingsGeneralLangCodePatchRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1SurveyExportSettingsGeneralLangCodeGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SurveyExportSettingsGeneralLangCodePatch(langCode, apiV1SurveyExportSettingsGeneralLangCodePatchRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyExportSettingsApi.apiV1SurveyExportSettingsGeneralLangCodePatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update the per-language report text blocks for a report language (creates new version)
         * @param {string} langCode Report language code (en, de, es, sk)
         * @param {ApiV1SurveyExportSettingsGeneralLangCodePatchRequest} [apiV1SurveyExportSettingsGeneralLangCodePatchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SurveyExportSettingsGeneralLangCodePatch_8(langCode: string, apiV1SurveyExportSettingsGeneralLangCodePatchRequest?: ApiV1SurveyExportSettingsGeneralLangCodePatchRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1SurveyExportSettingsGeneralLangCodeGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SurveyExportSettingsGeneralLangCodePatch_8(langCode, apiV1SurveyExportSettingsGeneralLangCodePatchRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyExportSettingsApi.apiV1SurveyExportSettingsGeneralLangCodePatch_8']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update general survey export settings (creates new version)
         * @param {ApiV1SurveyExportSettingsGeneralPatchRequest} [apiV1SurveyExportSettingsGeneralPatchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SurveyExportSettingsGeneralPatch(apiV1SurveyExportSettingsGeneralPatchRequest?: ApiV1SurveyExportSettingsGeneralPatchRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1SurveyExportSettingsGeneralGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SurveyExportSettingsGeneralPatch(apiV1SurveyExportSettingsGeneralPatchRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyExportSettingsApi.apiV1SurveyExportSettingsGeneralPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update general survey export settings (creates new version)
         * @param {ApiV1SurveyExportSettingsGeneralPatchRequest} [apiV1SurveyExportSettingsGeneralPatchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SurveyExportSettingsGeneralPatch_9(apiV1SurveyExportSettingsGeneralPatchRequest?: ApiV1SurveyExportSettingsGeneralPatchRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1SurveyExportSettingsGeneralGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SurveyExportSettingsGeneralPatch_9(apiV1SurveyExportSettingsGeneralPatchRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyExportSettingsApi.apiV1SurveyExportSettingsGeneralPatch_9']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete logo from survey export settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SurveyExportSettingsLogoDelete(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1SurveyExportSettingsLogoDelete200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SurveyExportSettingsLogoDelete(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyExportSettingsApi.apiV1SurveyExportSettingsLogoDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete logo from survey export settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SurveyExportSettingsLogoDelete_10(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1SurveyExportSettingsLogoDelete200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SurveyExportSettingsLogoDelete_10(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyExportSettingsApi.apiV1SurveyExportSettingsLogoDelete_10']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get survey export settings for user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SurveyExportSettingsLogoGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1SurveyExportSettingsAttachmentsAttachmentIdGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SurveyExportSettingsLogoGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyExportSettingsApi.apiV1SurveyExportSettingsLogoGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get survey export settings for user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SurveyExportSettingsLogoGet_11(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1SurveyExportSettingsAttachmentsAttachmentIdGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SurveyExportSettingsLogoGet_11(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyExportSettingsApi.apiV1SurveyExportSettingsLogoGet_11']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Upload logo for survey export settings
         * @param {File} logo Logo file (JPEG, PNG, GIF, WebP)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SurveyExportSettingsLogoPost(logo: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1SurveyExportSettingsAttachmentsAttachmentIdGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SurveyExportSettingsLogoPost(logo, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyExportSettingsApi.apiV1SurveyExportSettingsLogoPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Upload logo for survey export settings
         * @param {File} logo Logo file (JPEG, PNG, GIF, WebP)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SurveyExportSettingsLogoPost_12(logo: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1SurveyExportSettingsAttachmentsAttachmentIdGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SurveyExportSettingsLogoPost_12(logo, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyExportSettingsApi.apiV1SurveyExportSettingsLogoPost_12']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete signature from survey export settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SurveyExportSettingsSignatureDelete(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1SurveyExportSettingsSignatureDelete200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SurveyExportSettingsSignatureDelete(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyExportSettingsApi.apiV1SurveyExportSettingsSignatureDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete signature from survey export settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SurveyExportSettingsSignatureDelete_13(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1SurveyExportSettingsSignatureDelete200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SurveyExportSettingsSignatureDelete_13(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyExportSettingsApi.apiV1SurveyExportSettingsSignatureDelete_13']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get signature for survey export settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SurveyExportSettingsSignatureGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1SurveyExportSettingsAttachmentsAttachmentIdGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SurveyExportSettingsSignatureGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyExportSettingsApi.apiV1SurveyExportSettingsSignatureGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get signature for survey export settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SurveyExportSettingsSignatureGet_14(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1SurveyExportSettingsAttachmentsAttachmentIdGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SurveyExportSettingsSignatureGet_14(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyExportSettingsApi.apiV1SurveyExportSettingsSignatureGet_14']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Upload new signature for survey export settings
         * @param {File} signature Signature file (JPEG, PNG, GIF, WebP)
         * @param {string} title Title for the signature
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SurveyExportSettingsSignaturePost(signature: File, title: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1SurveyExportSettingsAttachmentsAttachmentIdGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SurveyExportSettingsSignaturePost(signature, title, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyExportSettingsApi.apiV1SurveyExportSettingsSignaturePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Upload new signature for survey export settings
         * @param {File} signature Signature file (JPEG, PNG, GIF, WebP)
         * @param {string} title Title for the signature
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SurveyExportSettingsSignaturePost_15(signature: File, title: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1SurveyExportSettingsAttachmentsAttachmentIdGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SurveyExportSettingsSignaturePost_15(signature, title, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyExportSettingsApi.apiV1SurveyExportSettingsSignaturePost_15']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete stamp from survey export settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SurveyExportSettingsStampDelete(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1SurveyExportSettingsStampDelete200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SurveyExportSettingsStampDelete(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyExportSettingsApi.apiV1SurveyExportSettingsStampDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete stamp from survey export settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SurveyExportSettingsStampDelete_16(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1SurveyExportSettingsStampDelete200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SurveyExportSettingsStampDelete_16(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyExportSettingsApi.apiV1SurveyExportSettingsStampDelete_16']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get stamp for survey export settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SurveyExportSettingsStampGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1SurveyExportSettingsAttachmentsAttachmentIdGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SurveyExportSettingsStampGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyExportSettingsApi.apiV1SurveyExportSettingsStampGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get stamp for survey export settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SurveyExportSettingsStampGet_17(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1SurveyExportSettingsAttachmentsAttachmentIdGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SurveyExportSettingsStampGet_17(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyExportSettingsApi.apiV1SurveyExportSettingsStampGet_17']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Upload new stamp for survey export settings
         * @param {File} stamp Stamp file (JPEG, PNG, GIF, WebP)
         * @param {string} title Title for the stamp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SurveyExportSettingsStampPost(stamp: File, title: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1SurveyExportSettingsAttachmentsAttachmentIdGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SurveyExportSettingsStampPost(stamp, title, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyExportSettingsApi.apiV1SurveyExportSettingsStampPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Upload new stamp for survey export settings
         * @param {File} stamp Stamp file (JPEG, PNG, GIF, WebP)
         * @param {string} title Title for the stamp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SurveyExportSettingsStampPost_18(stamp: File, title: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1SurveyExportSettingsAttachmentsAttachmentIdGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SurveyExportSettingsStampPost_18(stamp, title, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyExportSettingsApi.apiV1SurveyExportSettingsStampPost_18']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SurveyExportSettingsApi - factory interface
 */
export const SurveyExportSettingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SurveyExportSettingsApiFp(configuration)
    return {
        /**
         * 
         * @summary Delete attachment from survey export settings
         * @param {string} attachmentId Attachment ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyExportSettingsAttachmentsAttachmentIdDelete(attachmentId: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1SurveyExportSettingsAttachmentsAttachmentIdDelete200Response> {
            return localVarFp.apiV1SurveyExportSettingsAttachmentsAttachmentIdDelete(attachmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete attachment from survey export settings
         * @param {string} attachmentId Attachment ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyExportSettingsAttachmentsAttachmentIdDelete_1(attachmentId: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1SurveyExportSettingsAttachmentsAttachmentIdDelete200Response> {
            return localVarFp.apiV1SurveyExportSettingsAttachmentsAttachmentIdDelete_1(attachmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get specific attachment by ID
         * @param {string} attachmentId Attachment ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyExportSettingsAttachmentsAttachmentIdGet(attachmentId: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1SurveyExportSettingsAttachmentsAttachmentIdGet200Response> {
            return localVarFp.apiV1SurveyExportSettingsAttachmentsAttachmentIdGet(attachmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get specific attachment by ID
         * @param {string} attachmentId Attachment ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyExportSettingsAttachmentsAttachmentIdGet_2(attachmentId: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1SurveyExportSettingsAttachmentsAttachmentIdGet200Response> {
            return localVarFp.apiV1SurveyExportSettingsAttachmentsAttachmentIdGet_2(attachmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update attachment title and active status
         * @param {string} attachmentId Attachment ID
         * @param {ApiV1SurveyExportSettingsAttachmentsAttachmentIdPatchRequest} apiV1SurveyExportSettingsAttachmentsAttachmentIdPatchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyExportSettingsAttachmentsAttachmentIdPatch(attachmentId: string, apiV1SurveyExportSettingsAttachmentsAttachmentIdPatchRequest: ApiV1SurveyExportSettingsAttachmentsAttachmentIdPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1SurveyExportSettingsAttachmentsAttachmentIdGet200Response> {
            return localVarFp.apiV1SurveyExportSettingsAttachmentsAttachmentIdPatch(attachmentId, apiV1SurveyExportSettingsAttachmentsAttachmentIdPatchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update attachment title and active status
         * @param {string} attachmentId Attachment ID
         * @param {ApiV1SurveyExportSettingsAttachmentsAttachmentIdPatchRequest} apiV1SurveyExportSettingsAttachmentsAttachmentIdPatchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyExportSettingsAttachmentsAttachmentIdPatch_3(attachmentId: string, apiV1SurveyExportSettingsAttachmentsAttachmentIdPatchRequest: ApiV1SurveyExportSettingsAttachmentsAttachmentIdPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1SurveyExportSettingsAttachmentsAttachmentIdGet200Response> {
            return localVarFp.apiV1SurveyExportSettingsAttachmentsAttachmentIdPatch_3(attachmentId, apiV1SurveyExportSettingsAttachmentsAttachmentIdPatchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all attachments for survey export settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyExportSettingsAttachmentsGet(options?: RawAxiosRequestConfig): AxiosPromise<ApiV1SurveyExportSettingsAttachmentsAttachmentIdGet200Response> {
            return localVarFp.apiV1SurveyExportSettingsAttachmentsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all attachments for survey export settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyExportSettingsAttachmentsGet_4(options?: RawAxiosRequestConfig): AxiosPromise<ApiV1SurveyExportSettingsAttachmentsAttachmentIdGet200Response> {
            return localVarFp.apiV1SurveyExportSettingsAttachmentsGet_4(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload new attachment for survey export settings
         * @param {File} attachment Attachment file
         * @param {string} [title] Optional title for the attachment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyExportSettingsAttachmentsPost(attachment: File, title?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1SurveyExportSettingsAttachmentsAttachmentIdGet200Response> {
            return localVarFp.apiV1SurveyExportSettingsAttachmentsPost(attachment, title, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload new attachment for survey export settings
         * @param {File} attachment Attachment file
         * @param {string} [title] Optional title for the attachment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyExportSettingsAttachmentsPost_5(attachment: File, title?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1SurveyExportSettingsAttachmentsAttachmentIdGet200Response> {
            return localVarFp.apiV1SurveyExportSettingsAttachmentsPost_5(attachment, title, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get general survey export settings version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyExportSettingsGeneralGet(options?: RawAxiosRequestConfig): AxiosPromise<ApiV1SurveyExportSettingsGeneralGet200Response> {
            return localVarFp.apiV1SurveyExportSettingsGeneralGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get general survey export settings version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyExportSettingsGeneralGet_6(options?: RawAxiosRequestConfig): AxiosPromise<ApiV1SurveyExportSettingsGeneralGet200Response> {
            return localVarFp.apiV1SurveyExportSettingsGeneralGet_6(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the per-language report text blocks for a report language
         * @param {string} langCode Report language code (en, de, es, sk)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyExportSettingsGeneralLangCodeGet(langCode: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1SurveyExportSettingsGeneralLangCodeGet200Response> {
            return localVarFp.apiV1SurveyExportSettingsGeneralLangCodeGet(langCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the per-language report text blocks for a report language
         * @param {string} langCode Report language code (en, de, es, sk)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyExportSettingsGeneralLangCodeGet_7(langCode: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1SurveyExportSettingsGeneralLangCodeGet200Response> {
            return localVarFp.apiV1SurveyExportSettingsGeneralLangCodeGet_7(langCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update the per-language report text blocks for a report language (creates new version)
         * @param {string} langCode Report language code (en, de, es, sk)
         * @param {ApiV1SurveyExportSettingsGeneralLangCodePatchRequest} [apiV1SurveyExportSettingsGeneralLangCodePatchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyExportSettingsGeneralLangCodePatch(langCode: string, apiV1SurveyExportSettingsGeneralLangCodePatchRequest?: ApiV1SurveyExportSettingsGeneralLangCodePatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1SurveyExportSettingsGeneralLangCodeGet200Response> {
            return localVarFp.apiV1SurveyExportSettingsGeneralLangCodePatch(langCode, apiV1SurveyExportSettingsGeneralLangCodePatchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update the per-language report text blocks for a report language (creates new version)
         * @param {string} langCode Report language code (en, de, es, sk)
         * @param {ApiV1SurveyExportSettingsGeneralLangCodePatchRequest} [apiV1SurveyExportSettingsGeneralLangCodePatchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyExportSettingsGeneralLangCodePatch_8(langCode: string, apiV1SurveyExportSettingsGeneralLangCodePatchRequest?: ApiV1SurveyExportSettingsGeneralLangCodePatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1SurveyExportSettingsGeneralLangCodeGet200Response> {
            return localVarFp.apiV1SurveyExportSettingsGeneralLangCodePatch_8(langCode, apiV1SurveyExportSettingsGeneralLangCodePatchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update general survey export settings (creates new version)
         * @param {ApiV1SurveyExportSettingsGeneralPatchRequest} [apiV1SurveyExportSettingsGeneralPatchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyExportSettingsGeneralPatch(apiV1SurveyExportSettingsGeneralPatchRequest?: ApiV1SurveyExportSettingsGeneralPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1SurveyExportSettingsGeneralGet200Response> {
            return localVarFp.apiV1SurveyExportSettingsGeneralPatch(apiV1SurveyExportSettingsGeneralPatchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update general survey export settings (creates new version)
         * @param {ApiV1SurveyExportSettingsGeneralPatchRequest} [apiV1SurveyExportSettingsGeneralPatchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyExportSettingsGeneralPatch_9(apiV1SurveyExportSettingsGeneralPatchRequest?: ApiV1SurveyExportSettingsGeneralPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1SurveyExportSettingsGeneralGet200Response> {
            return localVarFp.apiV1SurveyExportSettingsGeneralPatch_9(apiV1SurveyExportSettingsGeneralPatchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete logo from survey export settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyExportSettingsLogoDelete(options?: RawAxiosRequestConfig): AxiosPromise<ApiV1SurveyExportSettingsLogoDelete200Response> {
            return localVarFp.apiV1SurveyExportSettingsLogoDelete(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete logo from survey export settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyExportSettingsLogoDelete_10(options?: RawAxiosRequestConfig): AxiosPromise<ApiV1SurveyExportSettingsLogoDelete200Response> {
            return localVarFp.apiV1SurveyExportSettingsLogoDelete_10(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get survey export settings for user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyExportSettingsLogoGet(options?: RawAxiosRequestConfig): AxiosPromise<ApiV1SurveyExportSettingsAttachmentsAttachmentIdGet200Response> {
            return localVarFp.apiV1SurveyExportSettingsLogoGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get survey export settings for user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyExportSettingsLogoGet_11(options?: RawAxiosRequestConfig): AxiosPromise<ApiV1SurveyExportSettingsAttachmentsAttachmentIdGet200Response> {
            return localVarFp.apiV1SurveyExportSettingsLogoGet_11(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload logo for survey export settings
         * @param {File} logo Logo file (JPEG, PNG, GIF, WebP)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyExportSettingsLogoPost(logo: File, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1SurveyExportSettingsAttachmentsAttachmentIdGet200Response> {
            return localVarFp.apiV1SurveyExportSettingsLogoPost(logo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload logo for survey export settings
         * @param {File} logo Logo file (JPEG, PNG, GIF, WebP)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyExportSettingsLogoPost_12(logo: File, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1SurveyExportSettingsAttachmentsAttachmentIdGet200Response> {
            return localVarFp.apiV1SurveyExportSettingsLogoPost_12(logo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete signature from survey export settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyExportSettingsSignatureDelete(options?: RawAxiosRequestConfig): AxiosPromise<ApiV1SurveyExportSettingsSignatureDelete200Response> {
            return localVarFp.apiV1SurveyExportSettingsSignatureDelete(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete signature from survey export settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyExportSettingsSignatureDelete_13(options?: RawAxiosRequestConfig): AxiosPromise<ApiV1SurveyExportSettingsSignatureDelete200Response> {
            return localVarFp.apiV1SurveyExportSettingsSignatureDelete_13(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get signature for survey export settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyExportSettingsSignatureGet(options?: RawAxiosRequestConfig): AxiosPromise<ApiV1SurveyExportSettingsAttachmentsAttachmentIdGet200Response> {
            return localVarFp.apiV1SurveyExportSettingsSignatureGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get signature for survey export settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyExportSettingsSignatureGet_14(options?: RawAxiosRequestConfig): AxiosPromise<ApiV1SurveyExportSettingsAttachmentsAttachmentIdGet200Response> {
            return localVarFp.apiV1SurveyExportSettingsSignatureGet_14(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload new signature for survey export settings
         * @param {File} signature Signature file (JPEG, PNG, GIF, WebP)
         * @param {string} title Title for the signature
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyExportSettingsSignaturePost(signature: File, title: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1SurveyExportSettingsAttachmentsAttachmentIdGet200Response> {
            return localVarFp.apiV1SurveyExportSettingsSignaturePost(signature, title, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload new signature for survey export settings
         * @param {File} signature Signature file (JPEG, PNG, GIF, WebP)
         * @param {string} title Title for the signature
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyExportSettingsSignaturePost_15(signature: File, title: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1SurveyExportSettingsAttachmentsAttachmentIdGet200Response> {
            return localVarFp.apiV1SurveyExportSettingsSignaturePost_15(signature, title, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete stamp from survey export settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyExportSettingsStampDelete(options?: RawAxiosRequestConfig): AxiosPromise<ApiV1SurveyExportSettingsStampDelete200Response> {
            return localVarFp.apiV1SurveyExportSettingsStampDelete(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete stamp from survey export settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyExportSettingsStampDelete_16(options?: RawAxiosRequestConfig): AxiosPromise<ApiV1SurveyExportSettingsStampDelete200Response> {
            return localVarFp.apiV1SurveyExportSettingsStampDelete_16(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get stamp for survey export settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyExportSettingsStampGet(options?: RawAxiosRequestConfig): AxiosPromise<ApiV1SurveyExportSettingsAttachmentsAttachmentIdGet200Response> {
            return localVarFp.apiV1SurveyExportSettingsStampGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get stamp for survey export settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyExportSettingsStampGet_17(options?: RawAxiosRequestConfig): AxiosPromise<ApiV1SurveyExportSettingsAttachmentsAttachmentIdGet200Response> {
            return localVarFp.apiV1SurveyExportSettingsStampGet_17(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload new stamp for survey export settings
         * @param {File} stamp Stamp file (JPEG, PNG, GIF, WebP)
         * @param {string} title Title for the stamp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyExportSettingsStampPost(stamp: File, title: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1SurveyExportSettingsAttachmentsAttachmentIdGet200Response> {
            return localVarFp.apiV1SurveyExportSettingsStampPost(stamp, title, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload new stamp for survey export settings
         * @param {File} stamp Stamp file (JPEG, PNG, GIF, WebP)
         * @param {string} title Title for the stamp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyExportSettingsStampPost_18(stamp: File, title: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1SurveyExportSettingsAttachmentsAttachmentIdGet200Response> {
            return localVarFp.apiV1SurveyExportSettingsStampPost_18(stamp, title, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SurveyExportSettingsApi - object-oriented interface
 */
export class SurveyExportSettingsApi extends BaseAPI {
    /**
     * 
     * @summary Delete attachment from survey export settings
     * @param {string} attachmentId Attachment ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1SurveyExportSettingsAttachmentsAttachmentIdDelete(attachmentId: string, options?: RawAxiosRequestConfig) {
        return SurveyExportSettingsApiFp(this.configuration).apiV1SurveyExportSettingsAttachmentsAttachmentIdDelete(attachmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete attachment from survey export settings
     * @param {string} attachmentId Attachment ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1SurveyExportSettingsAttachmentsAttachmentIdDelete_1(attachmentId: string, options?: RawAxiosRequestConfig) {
        return SurveyExportSettingsApiFp(this.configuration).apiV1SurveyExportSettingsAttachmentsAttachmentIdDelete_1(attachmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get specific attachment by ID
     * @param {string} attachmentId Attachment ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1SurveyExportSettingsAttachmentsAttachmentIdGet(attachmentId: string, options?: RawAxiosRequestConfig) {
        return SurveyExportSettingsApiFp(this.configuration).apiV1SurveyExportSettingsAttachmentsAttachmentIdGet(attachmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get specific attachment by ID
     * @param {string} attachmentId Attachment ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1SurveyExportSettingsAttachmentsAttachmentIdGet_2(attachmentId: string, options?: RawAxiosRequestConfig) {
        return SurveyExportSettingsApiFp(this.configuration).apiV1SurveyExportSettingsAttachmentsAttachmentIdGet_2(attachmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update attachment title and active status
     * @param {string} attachmentId Attachment ID
     * @param {ApiV1SurveyExportSettingsAttachmentsAttachmentIdPatchRequest} apiV1SurveyExportSettingsAttachmentsAttachmentIdPatchRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1SurveyExportSettingsAttachmentsAttachmentIdPatch(attachmentId: string, apiV1SurveyExportSettingsAttachmentsAttachmentIdPatchRequest: ApiV1SurveyExportSettingsAttachmentsAttachmentIdPatchRequest, options?: RawAxiosRequestConfig) {
        return SurveyExportSettingsApiFp(this.configuration).apiV1SurveyExportSettingsAttachmentsAttachmentIdPatch(attachmentId, apiV1SurveyExportSettingsAttachmentsAttachmentIdPatchRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update attachment title and active status
     * @param {string} attachmentId Attachment ID
     * @param {ApiV1SurveyExportSettingsAttachmentsAttachmentIdPatchRequest} apiV1SurveyExportSettingsAttachmentsAttachmentIdPatchRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1SurveyExportSettingsAttachmentsAttachmentIdPatch_3(attachmentId: string, apiV1SurveyExportSettingsAttachmentsAttachmentIdPatchRequest: ApiV1SurveyExportSettingsAttachmentsAttachmentIdPatchRequest, options?: RawAxiosRequestConfig) {
        return SurveyExportSettingsApiFp(this.configuration).apiV1SurveyExportSettingsAttachmentsAttachmentIdPatch_3(attachmentId, apiV1SurveyExportSettingsAttachmentsAttachmentIdPatchRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all attachments for survey export settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1SurveyExportSettingsAttachmentsGet(options?: RawAxiosRequestConfig) {
        return SurveyExportSettingsApiFp(this.configuration).apiV1SurveyExportSettingsAttachmentsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all attachments for survey export settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1SurveyExportSettingsAttachmentsGet_4(options?: RawAxiosRequestConfig) {
        return SurveyExportSettingsApiFp(this.configuration).apiV1SurveyExportSettingsAttachmentsGet_4(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload new attachment for survey export settings
     * @param {File} attachment Attachment file
     * @param {string} [title] Optional title for the attachment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1SurveyExportSettingsAttachmentsPost(attachment: File, title?: string, options?: RawAxiosRequestConfig) {
        return SurveyExportSettingsApiFp(this.configuration).apiV1SurveyExportSettingsAttachmentsPost(attachment, title, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload new attachment for survey export settings
     * @param {File} attachment Attachment file
     * @param {string} [title] Optional title for the attachment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1SurveyExportSettingsAttachmentsPost_5(attachment: File, title?: string, options?: RawAxiosRequestConfig) {
        return SurveyExportSettingsApiFp(this.configuration).apiV1SurveyExportSettingsAttachmentsPost_5(attachment, title, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get general survey export settings version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1SurveyExportSettingsGeneralGet(options?: RawAxiosRequestConfig) {
        return SurveyExportSettingsApiFp(this.configuration).apiV1SurveyExportSettingsGeneralGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get general survey export settings version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1SurveyExportSettingsGeneralGet_6(options?: RawAxiosRequestConfig) {
        return SurveyExportSettingsApiFp(this.configuration).apiV1SurveyExportSettingsGeneralGet_6(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the per-language report text blocks for a report language
     * @param {string} langCode Report language code (en, de, es, sk)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1SurveyExportSettingsGeneralLangCodeGet(langCode: string, options?: RawAxiosRequestConfig) {
        return SurveyExportSettingsApiFp(this.configuration).apiV1SurveyExportSettingsGeneralLangCodeGet(langCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the per-language report text blocks for a report language
     * @param {string} langCode Report language code (en, de, es, sk)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1SurveyExportSettingsGeneralLangCodeGet_7(langCode: string, options?: RawAxiosRequestConfig) {
        return SurveyExportSettingsApiFp(this.configuration).apiV1SurveyExportSettingsGeneralLangCodeGet_7(langCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update the per-language report text blocks for a report language (creates new version)
     * @param {string} langCode Report language code (en, de, es, sk)
     * @param {ApiV1SurveyExportSettingsGeneralLangCodePatchRequest} [apiV1SurveyExportSettingsGeneralLangCodePatchRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1SurveyExportSettingsGeneralLangCodePatch(langCode: string, apiV1SurveyExportSettingsGeneralLangCodePatchRequest?: ApiV1SurveyExportSettingsGeneralLangCodePatchRequest, options?: RawAxiosRequestConfig) {
        return SurveyExportSettingsApiFp(this.configuration).apiV1SurveyExportSettingsGeneralLangCodePatch(langCode, apiV1SurveyExportSettingsGeneralLangCodePatchRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update the per-language report text blocks for a report language (creates new version)
     * @param {string} langCode Report language code (en, de, es, sk)
     * @param {ApiV1SurveyExportSettingsGeneralLangCodePatchRequest} [apiV1SurveyExportSettingsGeneralLangCodePatchRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1SurveyExportSettingsGeneralLangCodePatch_8(langCode: string, apiV1SurveyExportSettingsGeneralLangCodePatchRequest?: ApiV1SurveyExportSettingsGeneralLangCodePatchRequest, options?: RawAxiosRequestConfig) {
        return SurveyExportSettingsApiFp(this.configuration).apiV1SurveyExportSettingsGeneralLangCodePatch_8(langCode, apiV1SurveyExportSettingsGeneralLangCodePatchRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update general survey export settings (creates new version)
     * @param {ApiV1SurveyExportSettingsGeneralPatchRequest} [apiV1SurveyExportSettingsGeneralPatchRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1SurveyExportSettingsGeneralPatch(apiV1SurveyExportSettingsGeneralPatchRequest?: ApiV1SurveyExportSettingsGeneralPatchRequest, options?: RawAxiosRequestConfig) {
        return SurveyExportSettingsApiFp(this.configuration).apiV1SurveyExportSettingsGeneralPatch(apiV1SurveyExportSettingsGeneralPatchRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update general survey export settings (creates new version)
     * @param {ApiV1SurveyExportSettingsGeneralPatchRequest} [apiV1SurveyExportSettingsGeneralPatchRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1SurveyExportSettingsGeneralPatch_9(apiV1SurveyExportSettingsGeneralPatchRequest?: ApiV1SurveyExportSettingsGeneralPatchRequest, options?: RawAxiosRequestConfig) {
        return SurveyExportSettingsApiFp(this.configuration).apiV1SurveyExportSettingsGeneralPatch_9(apiV1SurveyExportSettingsGeneralPatchRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete logo from survey export settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1SurveyExportSettingsLogoDelete(options?: RawAxiosRequestConfig) {
        return SurveyExportSettingsApiFp(this.configuration).apiV1SurveyExportSettingsLogoDelete(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete logo from survey export settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1SurveyExportSettingsLogoDelete_10(options?: RawAxiosRequestConfig) {
        return SurveyExportSettingsApiFp(this.configuration).apiV1SurveyExportSettingsLogoDelete_10(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get survey export settings for user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1SurveyExportSettingsLogoGet(options?: RawAxiosRequestConfig) {
        return SurveyExportSettingsApiFp(this.configuration).apiV1SurveyExportSettingsLogoGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get survey export settings for user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1SurveyExportSettingsLogoGet_11(options?: RawAxiosRequestConfig) {
        return SurveyExportSettingsApiFp(this.configuration).apiV1SurveyExportSettingsLogoGet_11(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload logo for survey export settings
     * @param {File} logo Logo file (JPEG, PNG, GIF, WebP)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1SurveyExportSettingsLogoPost(logo: File, options?: RawAxiosRequestConfig) {
        return SurveyExportSettingsApiFp(this.configuration).apiV1SurveyExportSettingsLogoPost(logo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload logo for survey export settings
     * @param {File} logo Logo file (JPEG, PNG, GIF, WebP)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1SurveyExportSettingsLogoPost_12(logo: File, options?: RawAxiosRequestConfig) {
        return SurveyExportSettingsApiFp(this.configuration).apiV1SurveyExportSettingsLogoPost_12(logo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete signature from survey export settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1SurveyExportSettingsSignatureDelete(options?: RawAxiosRequestConfig) {
        return SurveyExportSettingsApiFp(this.configuration).apiV1SurveyExportSettingsSignatureDelete(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete signature from survey export settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1SurveyExportSettingsSignatureDelete_13(options?: RawAxiosRequestConfig) {
        return SurveyExportSettingsApiFp(this.configuration).apiV1SurveyExportSettingsSignatureDelete_13(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get signature for survey export settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1SurveyExportSettingsSignatureGet(options?: RawAxiosRequestConfig) {
        return SurveyExportSettingsApiFp(this.configuration).apiV1SurveyExportSettingsSignatureGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get signature for survey export settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1SurveyExportSettingsSignatureGet_14(options?: RawAxiosRequestConfig) {
        return SurveyExportSettingsApiFp(this.configuration).apiV1SurveyExportSettingsSignatureGet_14(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload new signature for survey export settings
     * @param {File} signature Signature file (JPEG, PNG, GIF, WebP)
     * @param {string} title Title for the signature
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1SurveyExportSettingsSignaturePost(signature: File, title: string, options?: RawAxiosRequestConfig) {
        return SurveyExportSettingsApiFp(this.configuration).apiV1SurveyExportSettingsSignaturePost(signature, title, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload new signature for survey export settings
     * @param {File} signature Signature file (JPEG, PNG, GIF, WebP)
     * @param {string} title Title for the signature
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1SurveyExportSettingsSignaturePost_15(signature: File, title: string, options?: RawAxiosRequestConfig) {
        return SurveyExportSettingsApiFp(this.configuration).apiV1SurveyExportSettingsSignaturePost_15(signature, title, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete stamp from survey export settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1SurveyExportSettingsStampDelete(options?: RawAxiosRequestConfig) {
        return SurveyExportSettingsApiFp(this.configuration).apiV1SurveyExportSettingsStampDelete(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete stamp from survey export settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1SurveyExportSettingsStampDelete_16(options?: RawAxiosRequestConfig) {
        return SurveyExportSettingsApiFp(this.configuration).apiV1SurveyExportSettingsStampDelete_16(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get stamp for survey export settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1SurveyExportSettingsStampGet(options?: RawAxiosRequestConfig) {
        return SurveyExportSettingsApiFp(this.configuration).apiV1SurveyExportSettingsStampGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get stamp for survey export settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1SurveyExportSettingsStampGet_17(options?: RawAxiosRequestConfig) {
        return SurveyExportSettingsApiFp(this.configuration).apiV1SurveyExportSettingsStampGet_17(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload new stamp for survey export settings
     * @param {File} stamp Stamp file (JPEG, PNG, GIF, WebP)
     * @param {string} title Title for the stamp
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1SurveyExportSettingsStampPost(stamp: File, title: string, options?: RawAxiosRequestConfig) {
        return SurveyExportSettingsApiFp(this.configuration).apiV1SurveyExportSettingsStampPost(stamp, title, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload new stamp for survey export settings
     * @param {File} stamp Stamp file (JPEG, PNG, GIF, WebP)
     * @param {string} title Title for the stamp
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1SurveyExportSettingsStampPost_18(stamp: File, title: string, options?: RawAxiosRequestConfig) {
        return SurveyExportSettingsApiFp(this.configuration).apiV1SurveyExportSettingsStampPost_18(stamp, title, options).then((request) => request(this.axios, this.basePath));
    }
}

